import { render } from "./Agreement.vue?vue&type=template&id=7e29be18&scoped=true"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"

import "./Agreement.vue?vue&type=style&index=0&id=7e29be18&lang=scss&scoped=true"
import "./Agreement.vue?vue&type=style&index=1&id=7e29be18&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e29be18"]])

export default __exports__